// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CANCEL = "Zru\u0161";
export const MY_PRODUCTS_ADD = "P\u0159idej do profilu";
export const MY_PRODUCTS_EDIT = "Uprav";
export const MY_PRODUCTS_EDIT_CANCEL = "Hotovo";
export const MY_PRODUCTS_SELECT_ENTER_SOME_CHARS = "Zadej aspo\u0148 2 znaky z n\u00e1zvu";
export const USER_STROLLERS_ADD_NEXT_STROLLER = "P\u0159idej dal\u0161\u00ed ko\u010d\u00e1rek";
export const USER_STROLLERS_ADD_STROLLER = "P\u0159idej ko\u010d\u00e1rek";
export const USER_STROLLERS_SELECT_NO_RESULTS = "\u017d\u00e1dn\u00fd v\u00fdsledek";
